import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { DirectieSerii } from '../directie-serii.interface';
import { DirectieSeriiService } from '../directie-serii.service';

@Component({
    selector: 'app-edit-prefix',
    templateUrl: './edit-prefix.component.html',
    styleUrls: ['./edit-prefix.component.scss']
})
export class EditPrefixComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        id_sequence: new FormControl(null, []),
        prefix: new FormControl(this.data.prefix, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: DirectieSerii,
        private dialogRef: MatDialogRef<EditPrefixComponent>,
        private requestService: DirectieSeriiService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.findEntryData();
    }

    findEntryData() {
        this.requestService.findEntry(this.data.directie_id, this.data.id_compartiment)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe((res: any) => {
                const entryData: { id_sequence: string | -1, prefix: string | null } = res.data;
                console.log(entryData);
                this.form.get('id_sequence')?.setValue(entryData.id_sequence);
            });
    }

    submitForm() {
        this.isLoading = true;

        const { id_sequence, prefix } = this.form.value;
        const payload = {
            id_sequence,
            prefix
        };

        this.requestService
            .updatePrefix(this.data.directie_id, this.data.id_compartiment, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
